<template>
  <div class="ds-margin-bottom-48">
    <div
      v-for="index in itemsToLoad"
      :key="`status-section-group-${index}`"
      class="ds-width-full"
    >
    <StatusSectionLoader :type="type" :items-to-load="sectionItemsToLoad" />
    </div>
    <section>
      <div class="ds-container">
        <div class="ds-grid ds-justify-content-center">
          <div class="ds-grid__col ds-grid__col--12 ds-lg-grid__col--10">
            <div
              class="status-loading ds-margin-top-48"
              v-if="withButton"
              :style="{ height: '50px', width: '172px' }"
            />
            <span
              class="ds-padding-y-24 ds-md-padding-y-48"
              :style="{ display: 'block' }"
            ><DsDivider /></span>
            <div
              class="status-loading"
              :style="{ height: '28px', width: '160px' }"
            />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import DsDivider from 'website-design-system/src/atoms/divider/divider';
import { StatusSectionLoader } from '@/components';
export default {
  name: 'StatusSectionGroupLoader',
  components: { DsDivider, StatusSectionLoader },
  props: {
    itemsToLoad: {
      type: Number,
      default: 1
    },
    sectionItemsToLoad: {
      type: Number,
      default: 3
    },
    type: {
      type: String,
      required: true,
      validator: str => ['maintenance', 'incident'].includes(str)
    },
    withButton: {
      type: Boolean,
      default: false
    }
  }
}
</script>
